module.exports = __webpack_public_path__ + "media/polip_k.502469e6.mp3";